import { render, staticRenderFns } from "./ImgSlider.vue?vue&type=template&id=68bc710e&"
import script from "./ImgSlider.vue?vue&type=script&lang=js&"
export * from "./ImgSlider.vue?vue&type=script&lang=js&"
import style0 from "./ImgSlider.vue?vue&type=style&index=0&id=68bc710e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VContainer,VImg})
